import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

function PageBody({ children, px, py }) {
  return (
    <Box sx={{ width: "100%", py: py || 3, flex: 1, overflow: 'auto', minHeight: 0, px: px || 2 }}>
      {children}
    </Box>
  );
}

export default PageBody
